import { Environment } from './environment.interface';
import { baseEnvironment } from './environment.base';

/**
 * Test Environment Configuration
 *
 * Configuration for test environment.
 * Uses test/staging API endpoints and services.
 */

export const environment: Environment = {
  ...baseEnvironment,
  production: false,
  environmentName: 'test',
  apiEndpoints: {
    gatewayBaseUrl: 'https://test.api.smartlinks.dev',
    // Eventos & Conciertos (#173533): the admin calls the Events API directly until KrakenD routes events/*.
    eventsApiBaseUrl: 'https://events-tickets--linexrewards-app.us-east4.hosted.app/api'
  },
} as Environment;
